export const initialState = {smartvus: []};
